import React, { useState, useEffect, useMemo } from "react";
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import Layout from "./components/Layout";
import LoginPage from './components/LoginPage';
import RegisterFinishPage from './components/RegisterFinishPage';
import RegisterPage from './components/RegisterPage';
import ProfilePage from './components/ProfilePage';
import ProfileEditPage from './components/ProfileEditPage';
import CouponsListPage from './components/CouponsListPage';
import CouponPage from './components/CouponPage';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { getTodayWithoutTime } from "./utils/helper";

const StyledToastContainer = styled(ToastContainer).attrs({})`
  .Toastify__toast--dark {
    background-color: #323232;
  }
`;

function App() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [hasBg, setHasBg] = useState(true);
  const [isCenter, setIsCenter] = useState(true);
  const [cookies, setCookie] = useCookies();
  const [isExpired, setIsExpired] = useState(false);
  const [isEmptyExpired, setIsEmptyExpired] = useState(false);
  const [toLogout, setToLogout] = useState(false);

  const logoutTrue = () => {
    setToLogout(true);
  };

  useEffect(() => {
    const path = location.pathname.split('/');
    if (path[2] == "profile") {
      setHasBg(false);
      setIsCenter(false);
    } else {
      setHasBg(true);
      setIsCenter(true);
    }
  }, [location.pathname])

  useEffect(() => {
    var expiryDate = new Date(cookies.expiryDate);
    var isExpired = expiryDate < getTodayWithoutTime();
    setIsExpired(isExpired);
  }, [cookies])

  useEffect(() => {
    if (cookies.expiryDate == "no"){
      setIsEmptyExpired(true);
    }else{
      setIsEmptyExpired(false);
    }
  }, [cookies.expiryDate])

  useMemo(() => {
    let path = location.pathname.split('/');
    path = path.filter(o => o !== '');
    i18n.changeLanguage(path[0])
  },[])

  function Profiles({ match }) {
    return (
      (!isExpired && !isEmptyExpired) ?
        <>
          <Switch>
            <Route path={`${match.path}/coupons`} component={CouponsListPage} />
            <Route path={`${match.path}/coupon`} component={CouponPage} />
            <Route path={`${match.path}/edit`} component={ProfileEditPage} />
            <Route path={`${match.path}`} component={ProfilePage} />
          </Switch>
        </> :
        (
        isEmptyExpired ? 
          <Switch>
            <Route render={() => <Redirect to={`/${i18n.language}/resumepay`} />} />
          </Switch>
            :
          <Switch>
            <Route path={`${match.path}`} component={ProfilePage} />
          </Switch>
        )

    );
  }

  return (
    <Typography>
      <Layout background={hasBg} center={isCenter} toLogout={toLogout}>
        <Switch>
          <Route path="/:lng(en|tc|sc)/login" render={(props) => (<LoginPage {...props} isMember={cookies.token ? true : false} />)} />

          {/* <Route path="/:lng(en|tc|sc)/register" component={RegisterPage} />
          <Route path="/:lng(en|tc|sc)/renew" render={(props) => (<RegisterPage {...props} renew={true} />)} />
          <Route path="/:lng(en|tc|sc)/resumepay" render={(props) => (<RegisterPage {...props} resumepay={true} />)} /> */}

          {/* <Route path="/:lng(en|tc|sc)/:status(thankyou|fail)" component={RegisterFinishPage} /> */}
          <Route path="/:lng(en|tc|sc)?/:status(thankyou|fail)" render={(props) => (<RegisterFinishPage {...props} isRenew={cookies.token && isExpired ? true : false} isResumePay={isEmptyExpired ? true : false} toLogout={toLogout} logoutTrue={logoutTrue}/>)}  />

          {/* <Route path="/:lng(en|tc|sc)/profile"><Profiles/></Route> */}
          <Route path="/:lng(en|tc|sc)/profile" render={(props) => (cookies.token ? <Profiles {...props} /> : <Redirect to={`/${i18n.language}/login`} />)} />

          <Route render={() => <Redirect to={`/${i18n.language}/login`} />} />
        </Switch>
      </Layout>
      <StyledToastContainer
        position="bottom-center"
        transition={Slide}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
      />
    </Typography>
  );
}

export default App;
